export default {
  APP_INITIALIZING_CHANGED: 'app_initializing_changed',
  USER_CHANGED: 'user_changed',
  OPEN_SEARCH: 'open_search',
  CLOSE_SEARCH: 'close_search',
  PUSH_DATA_QUERY_SEARCH: 'push_data_query_search',
  CLEAR_DATA_QUERY_SEARCH: 'clear_data_query_search',
  IS_COUNT_SEARCH: 'is_count_search',
};
